export var E_ERROR_CODE_USER_CREATION;
(function (E_ERROR_CODE_USER_CREATION) {
    E_ERROR_CODE_USER_CREATION["USERNAME_CONFLICT"] = "USERNAME_CONFLICT";
    E_ERROR_CODE_USER_CREATION["EMAIL_CONFLICT"] = "EMAIL_CONFLICT";
})(E_ERROR_CODE_USER_CREATION || (E_ERROR_CODE_USER_CREATION = {}));
